/**
 * CART DEBUG - Script de diagnóstico para problemas no carrinho
 * Para usar: Adicione ?debug=cart na URL
 * Exemplo: https://sualoja.com/products/produto?debug=cart
 */

(function() {
  'use strict';
  
  // Só ativa se tiver ?debug=cart na URL
  var urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('debug') || urlParams.get('debug') !== 'cart') {
    return;
  }
  
  console.log('%c🔍 CART DEBUG MODE ATIVADO', 'background: #4CAF50; color: white; padding: 5px 10px; font-size: 14px; font-weight: bold;');
  
  // Cria painel de debug
  var debugPanel = document.createElement('div');
  debugPanel.id = 'cart-debug-panel';
  debugPanel.style.cssText = 'position: fixed; bottom: 20px; right: 20px; background: #1e1e1e; color: #fff; padding: 15px; border-radius: 8px; max-width: 400px; max-height: 500px; overflow-y: auto; z-index: 999999; font-family: monospace; font-size: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.5);';
  
  var debugContent = document.createElement('div');
  debugContent.innerHTML = '<h3 style="margin: 0 0 10px 0; color: #4CAF50;">🔍 Cart Debug</h3>';
  debugPanel.appendChild(debugContent);
  
  document.body.appendChild(debugPanel);
  
  function log(message, type) {
    type = type || 'info';
    var colors = {
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FF9800',
      error: '#F44336'
    };
    
    var logEntry = document.createElement('div');
    logEntry.style.cssText = 'margin: 5px 0; padding: 5px; background: rgba(255,255,255,0.1); border-left: 3px solid ' + colors[type] + '; border-radius: 3px;';
    logEntry.textContent = new Date().toLocaleTimeString() + ' - ' + message;
    debugContent.appendChild(logEntry);
    
    // Auto scroll
    debugPanel.scrollTop = debugPanel.scrollHeight;
    
    // Log no console também
    console.log('[Cart Debug]', message);
  }
  
  // Informações iniciais
  log('Debug iniciado', 'success');
  log('Página: ' + window.location.pathname, 'info');
  log('Tipo: ' + (window.theme ? window.theme.pageType : 'desconhecido'), 'info');
  log('Itens no carrinho: ' + (window.theme ? window.theme.cartCount : 'desconhecido'), 'info');
  
  // Verifica jQuery
  if (typeof jQuery !== 'undefined') {
    log('jQuery: v' + jQuery.fn.jquery, 'success');
  } else {
    log('jQuery: NÃO ENCONTRADO', 'error');
  }
  
  // Verifica formulários de produto
  var productForms = document.querySelectorAll('form[action*="/cart/add"]');
  log('Formulários encontrados: ' + productForms.length, productForms.length > 0 ? 'success' : 'warning');
  
  productForms.forEach(function(form, index) {
    var variantId = form.querySelector('[name="id"]');
    var quantity = form.querySelector('[name="quantity"]');
    
    log('Form ' + (index + 1) + ':', 'info');
    log('  - Variant ID: ' + (variantId ? variantId.value : 'AUSENTE'), variantId && variantId.value ? 'success' : 'error');
    log('  - Quantity: ' + (quantity ? quantity.value : 'AUSENTE'), quantity ? 'success' : 'warning');
  });
  
  // Verifica botões de adicionar
  var addButtons = document.querySelectorAll('[data-action="add-to-cart"]');
  log('Botões "Adicionar": ' + addButtons.length, addButtons.length > 0 ? 'success' : 'warning');
  
  // Monitora cliques nos botões
  document.addEventListener('click', function(e) {
    var target = e.target.closest('[data-action="add-to-cart"]');
    if (target) {
      log('🖱️ Botão clicado', 'info');
      
      var form = target.closest('form');
      if (form) {
        var formData = new FormData(form);
        var data = {};
        formData.forEach(function(value, key) {
          data[key] = value;
        });
        log('Dados do formulário: ' + JSON.stringify(data), 'info');
      } else {
        log('Formulário não encontrado!', 'error');
      }
    }
  }, true);
  
  // Monitora requisições fetch
  var originalFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var options = arguments[1] || {};
    
    if (url.includes('cart')) {
      log('📡 Fetch: ' + url, 'info');
      
      if (options.body) {
        try {
          var body = JSON.parse(options.body);
          log('Body: ' + JSON.stringify(body), 'info');
        } catch (e) {
          log('Body: ' + options.body, 'info');
        }
      }
    }
    
    return originalFetch.apply(this, arguments).then(function(response) {
      if (url.includes('cart')) {
        log('📥 Response: ' + response.status + ' ' + response.statusText, response.ok ? 'success' : 'error');
        
        // Clona a resposta para ler o body
        var clonedResponse = response.clone();
        clonedResponse.json().then(function(data) {
          log('Response data: ' + JSON.stringify(data).substring(0, 200), 'info');
        }).catch(function() {
          // Ignora erros de parse
        });
      }
      return response;
    }).catch(function(error) {
      if (url.includes('cart')) {
        log('❌ Erro na requisição: ' + error.message, 'error');
      }
      throw error;
    });
  };
  
  // Monitora eventos do carrinho
  document.addEventListener('product:added', function(e) {
    log('✅ Produto adicionado!', 'success');
    if (e.detail) {
      log('Variant: ' + (e.detail.variant ? e.detail.variant.id : 'N/A'), 'info');
      log('Quantity: ' + (e.detail.quantity || 'N/A'), 'info');
    }
  });
  
  document.addEventListener('cart:refresh', function() {
    log('🔄 Carrinho atualizado', 'info');
  });
  
  document.addEventListener('theme:loading:start', function() {
    log('⏳ Loading iniciado', 'info');
  });
  
  document.addEventListener('theme:loading:end', function() {
    log('⏹️ Loading finalizado', 'info');
  });
  
  // Monitora erros JavaScript
  window.addEventListener('error', function(e) {
    if (e.message.toLowerCase().includes('cart') || 
        e.filename.includes('theme') || 
        e.filename.includes('custom')) {
      log('❌ Erro JS: ' + e.message, 'error');
      log('Arquivo: ' + e.filename + ':' + e.lineno, 'error');
    }
  });
  
  // Botão para limpar o painel
  var clearBtn = document.createElement('button');
  clearBtn.textContent = 'Limpar';
  clearBtn.style.cssText = 'margin-top: 10px; padding: 5px 10px; background: #F44336; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 11px;';
  clearBtn.onclick = function() {
    debugContent.innerHTML = '<h3 style="margin: 0 0 10px 0; color: #4CAF50;">🔍 Cart Debug</h3>';
    log('Painel limpo', 'info');
  };
  debugPanel.appendChild(clearBtn);
  
  // Botão para fechar
  var closeBtn = document.createElement('button');
  closeBtn.textContent = 'Fechar';
  closeBtn.style.cssText = 'margin-top: 10px; margin-left: 5px; padding: 5px 10px; background: #757575; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 11px;';
  closeBtn.onclick = function() {
    debugPanel.remove();
  };
  debugPanel.appendChild(closeBtn);
  
  // Botão para exportar log
  var exportBtn = document.createElement('button');
  exportBtn.textContent = 'Exportar';
  exportBtn.style.cssText = 'margin-top: 10px; margin-left: 5px; padding: 5px 10px; background: #2196F3; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 11px;';
  exportBtn.onclick = function() {
    var logs = Array.from(debugContent.querySelectorAll('div')).map(function(div) {
      return div.textContent;
    }).join('\n');
    
    var blob = new Blob([logs], { type: 'text/plain' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'cart-debug-' + Date.now() + '.txt';
    a.click();
    URL.revokeObjectURL(url);
    
    log('Log exportado', 'success');
  };
  debugPanel.appendChild(exportBtn);
  
  log('Debug pronto! Tente adicionar um produto ao carrinho.', 'success');
  
})();
